var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isModalVisible,
          expression: "isModalVisible"
        }
      ]
    },
    [
      _c("div", { staticClass: "modal-mask", on: { click: _vm.closeModal } }, [
        _c(
          "div",
          {
            staticClass: "modal-container",
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "button",
                {
                  staticClass: "close float-right",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: { click: _vm.closeModal }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "row arrow_icons" }, [
                _c("div", { staticClass: "reps_prev" }, [
                  _vm.index > 0
                    ? _c(
                        "a",
                        {
                          attrs: { href: "javascript:void(0);" },
                          on: {
                            click: function($event) {
                              return _vm.getNextPrev("Previous")
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-angle-left" })]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "reps_next" }, [
                  _vm.repCount > 1 && parseInt(_vm.index + 1) < _vm.repCount
                    ? _c(
                        "a",
                        {
                          attrs: { href: "javascript:void(0);" },
                          on: {
                            click: function($event) {
                              return _vm.getNextPrev("Next")
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-angle-right" })]
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-heading" }, [
                _c("h5", { staticClass: "col-12 modal-title" }, [
                  _vm._v(
                    "Review Reps (" +
                      _vm._s(parseInt(_vm.index + 1) + "/" + _vm.repCount) +
                      ")"
                  )
                ]),
                _vm._v(" "),
                _c("h6", { staticClass: "col-12 mentee_name" }, [
                  _vm._v(_vm._s(_vm.menteeFirstName + " " + _vm.menteeLastName))
                ]),
                _vm._v(" "),
                _c("hr")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-sub-heading" }, [
                _c("div", { staticClass: "sub-heading-label" }, [
                  _vm._v("Date: "),
                  _c("span", [
                    _vm._v(_vm._s(_vm._f("format1Date")(_vm.repCreatedAt)))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "sub-heading-label ml-4" }, [
                  _vm._v("Time: "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm._f("format2Date")(_vm.repCreatedAt)) + " - CST"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-task-heading" }, [
                _c("div", { staticClass: "sub-heading-label" }, [
                  _vm._v("Task List: "),
                  _c("span", [_vm._v(_vm._s(_vm.taskListName))])
                ]),
                _vm._v(" "),
                !_vm.isSection
                  ? _c("div", { staticClass: "sub-heading-label" }, [
                      _vm._v("Task: "),
                      _c("span", [_vm._v(_vm._s(_vm.taskName))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isSection
                  ? _c("div", { staticClass: "sub-heading-label" }, [
                      _vm._v("Section: "),
                      _c("span", [_vm._v(_vm._s(_vm.taskName))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isSection
                  ? _c("div", [
                      _c("div", { staticClass: "font-weight-bold" }, [
                        _vm._v("Tasks")
                      ]),
                      _vm._v(" "),
                      _c(
                        "ol",
                        _vm._l(_vm.subtaskTasks, function(item, index) {
                          return _c("li", { key: index }, [
                            _vm._v(_vm._s(item.description))
                          ])
                        }),
                        0
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "review-form" },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.submit_form_errors,
                          expression: "submit_form_errors"
                        }
                      ],
                      staticClass: "validate-warning-msg-login"
                    },
                    [_vm._v(_vm._s(_vm.submit_form_errors))]
                  ),
                  _vm._v(" "),
                  _vm.status == 0
                    ? _c("form", [
                        _c("div", { staticClass: "form-group row" }, [
                          _c("label", { staticClass: "col-12 form-label" }, [
                            _vm._v("Mentee Submitted Task Time: ")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("date-picker", {
                                ref: "timepicker",
                                attrs: {
                                  name: "Time spent on task",
                                  type: "time",
                                  format: "HH:mm",
                                  placeholder: "Hours:Minutes",
                                  "popup-style": _vm.timePickerStyle,
                                  clearable: false,
                                  editable: false
                                },
                                on: { change: _vm.inputHandler },
                                model: {
                                  value: _vm.display_time,
                                  callback: function($$v) {
                                    _vm.display_time = $$v
                                  },
                                  expression: "display_time"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _vm.subtaskId != 99999
                          ? _c("div", { staticClass: "form-group row" }, [
                              _c(
                                "label",
                                { staticClass: "col-12 form-label" },
                                [_vm._v("Update Competency Rating?:")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      },
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.score,
                                        expression: "score"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: { name: "Rate This Repetition" },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.score = $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  [
                                    _c("option", { attrs: { value: "" } }, [
                                      _vm._v("Select Rating")
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(_vm.items_options, function(
                                      item,
                                      index
                                    ) {
                                      return _c(
                                        "option",
                                        {
                                          key: index,
                                          domProps: { value: item.value }
                                        },
                                        [_vm._v(_vm._s(item.display))]
                                      )
                                    })
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _vm.verrors.firstByRule(
                                  "Rate This Repetition",
                                  "required"
                                )
                                  ? _c(
                                      "div",
                                      {
                                        class:
                                          "validate-warning-msg " + _vm.vmessage
                                      },
                                      [
                                        _vm._v(
                                          "Rate This Repetition is required"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.mentee_comments && _vm.subtaskId != 99999
                          ? _c("div", { staticClass: "form-group row" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _c("b", [_vm._v("Mentee Comment: ")]),
                                _vm._v(
                                  "  " +
                                    _vm._s(_vm.mentee_comments) +
                                    "                \n                "
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.commentsShow == 0 && _vm.subtaskId != 99999
                          ? _c("div", { staticClass: "form-group row" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "col-12 form-label show_comment",
                                  attrs: { href: "javascript:void(0);" },
                                  on: {
                                    click: function($event) {
                                      _vm.commentsShow = 1
                                    }
                                  }
                                },
                                [_vm._v("+ Add Comment for Mentee")]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.commentsShow == 1 && _vm.subtaskId != 99999
                          ? _c("div", { staticClass: "form-group row" }, [
                              _c(
                                "label",
                                { staticClass: "col-12 form-label" },
                                [_vm._v("Comment for mentee:")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12" }, [
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.comments,
                                      expression: "comments"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    name: "Comment for mentee",
                                    placeholder: "Enter Comment for Mentee",
                                    maxLength: "180"
                                  },
                                  domProps: { value: _vm.comments },
                                  on: {
                                    blur: _vm.characterCount,
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.comments = $event.target.value
                                      },
                                      _vm.characterCount
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "hint" }, [
                                  _vm._v(
                                    _vm._s(
                                      this.remainCharacters + " Characters"
                                    )
                                  )
                                ])
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "row center_div" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-6 col-sm-6 col-md-6 col-lg-6 col-xl-4"
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-sm btn-blue denyBtn",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.onSubmit("Denied")
                                    }
                                  }
                                },
                                [_vm._v("Deny")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-6 col-sm-6 col-md-6 col-lg-6 col-xl-4"
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-sm btn-blue approveBtn",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.onSubmit("Approved")
                                    }
                                  }
                                },
                                [_vm._v("Approve")]
                              )
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("hr", { staticClass: "custom_hr" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "reps_history_label" }, [
                    _c(
                      "a",
                      {
                        attrs: { href: "javascript:void(0);" },
                        on: { click: _vm.showRepsHistory }
                      },
                      [
                        _vm._v(
                          "\n                See Repetition History for this task "
                        ),
                        _c("i", {
                          class: _vm.toggleFontIcon,
                          staticStyle: { "font-size": "18px" }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("RepetitionHistory", {
                    ref: "reps_history",
                    attrs: {
                      menteeId: _vm.menteeId,
                      tasklistId: _vm.tasklistId,
                      taskId: this.taskId,
                      parent_form: "review_reps",
                      isSection: _vm.isSection
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c("h5", { staticClass: "col-12 modal-title" }, [
                _vm._v(
                  "Review Reps (" +
                    _vm._s(parseInt(_vm.index + 1) + "/" + _vm.repCount) +
                    ")"
                )
              ])
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3be622f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3be622f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/manager/MenteeReviewRepetitionAllTasklists.vue
// module id = null
// module chunks = 